// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header--2TUzx","Header-video":"Header-video--28LTz","Header-logo":"Header-logo--HMtKT","Header-heading":"Header-heading--TuL4q","Header-content":"Header-content--1zcIH"};